<template>
  <div class="w-full">
    <BaseButton
      :primary="true"
      :step="step"
      @click="launchModal"
    >
      {{ step.action }}
    </BaseButton>
  </div>
</template>

<script lang="ts" setup>
import {inject} from "vue";
import {Pathway, PathwayStep} from "@/program/interfaces/Program";
import BaseButton from "@/core/components/base/BaseButton.vue";

const openSurveyModal = inject<{
    (surveyId: number, consumerKey: string, stepId: number, supportId: number, type: string, options: unknown): void
        }>('openSurveyModal');

const props = defineProps<{
    step: PathwayStep;
    consumerKey: string;
    pathway: Pathway;
}>();

/**
 * Launch the survey full screen modal.
 */
const launchModal = () => {
    return openSurveyModal!(
        props.step.steppable.id,
        props.consumerKey,
        props.step.id,
        props.pathway.support_program_id,
        props.step.type,
        {consent: props.step.steppable.consent}
    );
};

</script>
